export default "__VITE_ASSET__BLuWDZuL__"